export enum BusinessProfileTabs {
  baseData = 'baseData',
  category = 'category',
  terms = 'terms',
  newTerms = 'newTerms',
}
